module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"step":"Integration","publish":"Publish","saveDraft":"Save draft","lostInfoWarning":"Changes not saved will be lost. Are you sure?","continue":"Continue editing","goBack":"Go back"}}')
  delete Component.options._Ctor
}
